module.exports = __webpack_public_path__ + "img/program_example_rune_output.f86cddf3.png";